/**
 * 串口列表 Hook
 * 提供串口枚举和串口列表刷新功能
 */
import { useEffect, useCallback } from 'react';
import { useWebSocket } from './use-websocket';
import { useConnectionStore } from '@/stores/connection';
import type { SerialPortInfo } from '@fluxlab/protocols';

/** 串口列表 Hook：拉取并刷新可用串口列表 */
export function useSerialPorts() {
  const { send, isConnected } = useWebSocket();
  const ports = useConnectionStore((s) => s.ports);
  const selectedPort = useConnectionStore((s) => s.port);
  const baudRate = useConnectionStore((s) => s.baudRate);
  const setPort = useConnectionStore((s) => s.setPort);
  const setBaudRate = useConnectionStore((s) => s.setBaudRate);

  const listPorts = useCallback(() => {
    send({ type: 'list-ports' });
  }, [send]);

  useEffect(() => {
    if (!isConnected) return;
    listPorts();
    const interval = setInterval(listPorts, 5000);
    return () => clearInterval(interval);
  }, [isConnected, listPorts]);

  return {
    ports,
    selectedPort,
    baudRate,
    setPort,
    setBaudRate,
    listPorts,
  };
}
